import React, { useState, useEffect, useRef } from 'react';
import { object, func, string } from 'prop-types';
import LayoutTwoVerticalGrids from '../../ui-components/layouts/layout-two-vertical-grids.jsx';
import SearchCriteria from '../../ui-components/core-pricing-component/search-cirteria/search-criteria.jsx';
import TableView from '../../ui-components/core-pricing-component/table-view/table-view.jsx';
import { toast } from 'react-toast';
import { DateUtil } from '../../utils/date-util.js';
import moment from 'moment-timezone';
import {
    URL_CORE_PRICING_SEARCH,
    URL_DYNAMIC_RESOLUTION,
    URL_SAVE_CRITERIA,
    URL_SAVE_CRITERIA_FILTER_OF_USER_ID,
    URL_CORE_PRICING_SAVE_CRITERIA_FILTER_OF_CONTEXT_ID
} from '../../end-points.js';
import useApi from '../../api-wrapper/use-api.js';
import Loader from '../../ui-components/loader/loader.jsx';
import axios from 'axios';
import getFormattedError from '../../api-wrapper/get-formatted-error';
import {
    calculateHeader,
    calculateJoinData,
    calculateParsingData,
    calculateSeprationTableCaption,
    generationgTableObjects,
    calculateResultDetails,

} from '../../utils/common-util.js';
import {
    TOOL_BAR_BUTTONS,
    SIZE

} from '../../utils/constants.js';
import { values } from 'lodash';
const CorePricingFares = ({ app, getTableData, getSearchCriteriaParent, loadTime, getFullDataIsAvailable }) => {
    // const CancelToken = axios.CancelToken;
    // const cancelTokenSource = new AbortController();
    const [cancelToken, setCancelToken] = useState(null);
    const [stopApiRequest, setStopApiRequest] = useState(false);
    const [fetchConfig, setFetchConfig] = useState({
        data: [],
        isLoading: false,
        error: '',
        requestedData: [],
        pageToken: null,
        jobId: null,
        table: '',
        type: 'search_action',
        isStopAPI: false,
        totalItem: 0
    });
    const [corePricingConfig, setCorePricingConfig] = useState({
        isShowStoredCriteriaPopupModal: false,
        sepratorCaption: 0,
        storedCriteriaData: [],
        primaryTable: [],
        secondaryTable: [],
        primaryHeaderDetails: [],
        secondaryHeaderDetails: [],
        joinTableData: [],
        joinTableHeaders: [],
        isOpenStoredCriteria: false,
        filterUniqueValues: [],
        isLeftSideLayoutOpen: true,
        selectedTab: TOOL_BAR_BUTTONS[0].KEY,
        titleDetails: [],
        isSaveSearchCriteria: false,
        selectedRowDetails: {},
        selectedCellIndex: -2,
        isFilterApply: false,
        pageToken: null
    });
    const [abort, setAbort] = useState({
        isAbort: false,
        searchCriteriaDetails: []
    });
    const [isShowNotification, setIsShowNotification] = useState(false);
    let isEmptyValue = false;
    const primaryTableReference = useRef();
    const secondaryTableReference = useRef();
    const [searchCriteriaConfig, setSearchCriteriaConfig] = useState({});
    const [isTariffNumberAvailable, setIsTariffNumberAvailable] = useState(false);
    const [searchUrl, setSearchUrl] = useState('');


    useEffect(() => {
        if (app.foSimpleHep.FO_NGDS_DYNAMIC_RESOLUTION) {
            setSearchUrl(URL_DYNAMIC_RESOLUTION);
        }
        else {
            setSearchUrl(URL_CORE_PRICING_SEARCH);
        }

    }, []);

    useEffect(() => {
        getSearchCriteriaParent(searchCriteriaConfig);
    }, [searchCriteriaConfig]);

    const getSearchCriteria = (searchCriteria, type, title) => {
        setSearchCriteriaConfig(searchCriteria);
        if (type === 'clear') {
            setFetchConfig(
                {
                    ...fetchConfig,
                    isLoading: false,
                    error: '',
                    requestedData: {
                        hostCarrier: fetchConfig.requestedData.hostCarrier
                    },
                    pageToken: undefined,
                    //  jobId: null,
                    table: '',
                    type: 'search_action',
                    isStopAPI: !fetchConfig.isStopAPI ? false : true
                }
            )
            setIsTariffNumberAvailable(false);
            setStopApiRequest(false);
        }
        if (title)
            setSavedSearchCriteriaTitle(title);
    };
    //  const URL_SAVED_CRITERIA_SEARCH_USER_ID = `${URL_SAVE_CRITERIA}${URL_CORE_PRICING_SAVE_CRITERIA_FILTER_OF_CONTEXT_ID}-'${URL_SAVE_CRITERIA_FILTER_OF_USER_ID}'${app.User.userId}'`;
    const callFetchFaresService = async () => {

        const headers = {};
        const requestObject = Object.assign(fetchConfig);
        if (requestObject.type === 'search_action') {
            //  requestObject.pageToken = null;
            //  cancelTokenSource.abort();
            if (cancelToken) {
                cancelToken.cancel('Query canceled.');
            }
            requestObject.requestedData.pageToken = null;
            requestObject.requestedData.bqJobInfo = null;
            // requestObject.jobId = null;
        } else if (requestObject.totalItem) {
            // requestObject.pageToken = requestObject.pageToken;
            requestObject.requestedData.pageToken = requestObject.pageToken;
            requestObject.requestedData.bqJobInfo = requestObject.jobId;
        }
        delete requestObject.requestedData.jobId;
        requestObject.requestedData.latestLoadTransmission = loadTime;

        const source = axios.CancelToken.source();
        setCancelToken(source);
        try {
            const fetchResultData = await axios({
                url: searchUrl,
                method: 'POST',
                //signal: cancelTokenSource.signal,
                cancelToken: source.token,
                headers: {
                    'content-type': 'application/json',
                    ...headers
                },
                data: requestObject.requestedData
            }).catch((err) => {
                console.log(err, 'err');
                setFetchConfig({
                    ...fetchConfig,
                    error: err.message,
                    data: [],
                    isLoading: false,
                });

            });
            if (fetchResultData) {
                if (corePricingConfig.joinTableData.length !== parseInt(fetchResultData && fetchResultData.data && fetchResultData.data.totalNumberOfFaresFound) || parseInt(fetchResultData.data.totalNumberOfFaresFound) === 0)
                    setFetchConfig({
                        ...fetchConfig,
                        data: fetchResultData.data.resolvedFares,
                        totalItem: requestObject.type === 'search_action' ? fetchResultData.data.totalNumberOfFaresFound : fetchConfig.totalItem,
                        jobId: !fetchConfig.jobId ? fetchResultData.data.jobId : fetchConfig.jobId,
                        pageToken: fetchResultData.data.pageToken,
                        isLoading: false,
                        error: '',
                        isStopAPI: false
                    })
            }

        } catch (error) {
            console.log(error)
            setFetchConfig({
                ...fetchConfig,
                data: [],
                isLoading: false,
                error: getFormattedError(error).content
            });
            setAbort({
                isAbort: false
            });
        }
    };
    useEffect(() => {
        // if (fetchConfig.error === 'canceled' && abort.isAbort) {
        //     searchCriteriaParsing(abort.searchCriteriaDetails);
        // } else 
        if (fetchConfig.error) {
            toast.warn(fetchConfig.error);
        }
        getTableData({ joinTable: corePricingConfig.joinTableData, primaryTableLength: corePricingConfig.primaryTable.length, totalItem: fetchConfig.totalItem, isCompleted: true });
    }, [fetchConfig.error]);

    useEffect(() => {
        if (abort.isAbort) {
            searchCriteriaParsing(abort.searchCriteriaDetails);
            setAbort({
                ...abort,
                isAbort: false
            });
            return;
        }
        if (corePricingConfig.pageToken) {
            navigationPagination();
        } else if (typeof (fetchConfig.pageToken) === 'undefined' && corePricingConfig.joinTableData.length > 0)
            toast.success(`Successfully fetched ${!fetchConfig.isStopAPI ? 'all' : ''} data.Export data available now`, { backgroundColor: '#268440' });
        getTableData({ joinTable: corePricingConfig.joinTableData, primaryTableLength: corePricingConfig.primaryTable.length, totalItem: fetchConfig.totalItem, isCompleted: typeof (fetchConfig.pageToken) === 'undefined' ? true : false });
        // getFullDataIsAvailable();
    }, [corePricingConfig.pageToken])

    const emptyValidation = (value) => {
        return value ? value : '';
    };
    const emptyArrayValidation = (value) => {
        return value && value.toString().length > 0 ? value.toString() : '';
    };
    const amountEmptyFieldValidation = (value) => {
        return value ? value : 0;
    };
    const dateFormat = (date) => {
        return (DateUtil.formatDate(date, DateUtil.DATE_FORMATS.DD_MMM_YY)).toString().toUpperCase();
    };
    const dateTimeFormat = (date) => {
        return (DateUtil.formatDate(date, DateUtil.DATE_FORMATS.DD_MMM_YY_TIME)).toString().toUpperCase();
    };

    useEffect(() => {
        if (fetchConfig.isLoading && !corePricingConfig.isSaveSearchCriteria && (fetchConfig.type === 'pagination_action' || fetchConfig.type === 'search_action')) {
            callFetchFaresService();
        }
    }, [fetchConfig.isLoading]);

    const parsingOriginalData = (data) => {
        let primaryData = [];
        let secondaryData = [
            {
                categoryTitle: 'fareValue',
                data: []
            },
            {
                categoryTitle: 'rule',
                data: []
            },
            {
                categoryTitle: 'footnote',
                data: []
            },
            {
                categoryTitle: 'distribution',
                data: []
            },
            {
                categoryTitle: 'fareClass',
                data: []
            },
            {
                categoryTitle: 'brand',
                data: []
            },
            {
                categoryTitle: 'market',
                data: []
            }
        ];
        if (data && data.length > 0) {
            data.map((item) => {
                const { origin, destination, carrierCode, fareClassCode, tariffNumber, footnoteCode, routingNumber,
                    actionCode, roundTripIndicator, currencyCode, fareAmount, surchargeAmount, yqAmount, yrAmount, aggregatedTax,
                    totalFare, cabinCode, rbds, fareTypeCode, dayOfWeekTypeCode, seasonTypeCode, passengerTypes, ticketDesignators, footnoteReservationFromDate, footnoteReservationToDate, footnoteTicketingFromDate,
                    footnoteTicketingToDate, footnoteOutboundTravelFromDate, footnoteOutboundTravelToDate, footnoteOutboundTravelCompleteDate,
                    footnoteTravelDates, footnoteSeasonDates, footnoteBlackOutDates, traveldate, ruleNumber, dow, ruleSeasonDates, advancePurchaseReservation, ruleTravelDates, applicableDates, minStay, maxStay, ruleBlackOutDates,
                    effectiveDate, discontinueDate, receivedDate, minstayNumber, minstaydayofweeksurcharges, gfsUniqueFillingCode, gfsDate, origincountrycode, desiginationcountrycode, market, brand, branddetails } = item;

                const primary = { org: origin, des: destination, cxr: carrierCode, fbc: fareClassCode, tar: tariffNumber, ft: emptyValidation(footnoteCode), rtg: routingNumber };
                const fareValue = {
                    vcc: emptyValidation(actionCode), owrt: emptyValidation(roundTripIndicator), cur: emptyValidation(currencyCode), amt: amountEmptyFieldValidation(fareAmount), sur: surchargeAmount, yq: yqAmount, yr: yrAmount,
                    tax: aggregatedTax, ttl: amountEmptyFieldValidation(totalFare)
                };
                const footnote = {
                    'fst res': emptyArrayValidation(footnoteReservationFromDate), 'lst res': emptyArrayValidation(footnoteReservationToDate), 'fst tkt': emptyArrayValidation(footnoteTicketingFromDate), 'lst tkt': emptyArrayValidation(footnoteTicketingToDate),
                    'tvl st': emptyArrayValidation(footnoteOutboundTravelFromDate), 'tvl end': emptyArrayValidation(footnoteOutboundTravelToDate), 'tvl cmplt': emptyArrayValidation(footnoteOutboundTravelCompleteDate), 'ft tvl dt': emptyArrayValidation(footnoteTravelDates),
                    'ft seas dt': emptyArrayValidation(footnoteSeasonDates), 'ft bo dt': emptyArrayValidation(footnoteBlackOutDates)
                };
                const fareClass = {
                    'cab': emptyValidation(cabinCode), 'rbd': emptyValidation(rbds), 'ftc': emptyValidation(fareTypeCode), 'dow tc': emptyValidation(dayOfWeekTypeCode), 'seas tc': emptyValidation(seasonTypeCode), 'ptc': emptyValidation(passengerTypes),
                    'tkt dsg': emptyValidation(ticketDesignators)
                };
                const rule = {
                    rule: emptyValidation(ruleNumber), 'dow': dow, 'seas dt': emptyValidation(ruleSeasonDates), ap: advancePurchaseReservation, 'rule tvl dt': emptyValidation(ruleTravelDates), 'appl dt': emptyValidation(applicableDates),
                    'min st': minStay, 'max st': maxStay, 'bo dt': emptyValidation(ruleBlackOutDates)
                };
                const marketDetails = { oc: emptyValidation(origincountrycode), dc: emptyValidation(desiginationcountrycode), mkt: emptyValidation(market) };
                const brandDetails = { brd: emptyValidation(brand), 'brd det': emptyValidation(branddetails) };
                const distribution = { 'eff dt': dateFormat(emptyValidation(effectiveDate)), 'disc dt': emptyValidation(discontinueDate), 'rec dt': receivedDate ? dateTimeFormat(emptyValidation(receivedDate)) : '', 'gfs': emptyValidation(gfsUniqueFillingCode), 'gfs dt': emptyValidation(gfsDate) };

                secondaryData[0].data.push(fareValue);
                secondaryData[1].data.push(rule);
                secondaryData[2].data.push(footnote);
                secondaryData[3].data.push(distribution);
                secondaryData[4].data.push(fareClass);
                secondaryData[5].data.push(brandDetails);
                secondaryData[6].data.push(marketDetails);
                primaryData.push(primary);
            });
            const primaryHeader = calculateHeader(primaryData[0]);
            const parsingData = calculateParsingData(secondaryData);
            const secondaryHeader = calculateHeader(parsingData.tableData);
            const sepratorCaption = calculateSeprationTableCaption(secondaryHeader);
            const joinHeaders = [...primaryHeader, ...secondaryHeader];
            const splitingObjects = calculateJoinData(primaryData, parsingData.mergedSecondaryTable);
            const result = generationgTableObjects(splitingObjects);
            const finalPrimaryCollection = fetchConfig.type !== 'search_action' ? corePricingConfig.primaryTable.concat(result.primaryCollection) : result.primaryCollection;
            const finalSecondaryCollection = fetchConfig.type !== 'search_action' ? corePricingConfig.secondaryTable.concat(result.secondaryCollection) : result.secondaryCollection;
            calculateResultDetails(finalPrimaryCollection, primaryHeader);
            calculateResultDetails(finalSecondaryCollection, secondaryHeader);
            setCorePricingConfig({
                ...corePricingConfig,
                joinTableHeaders: joinHeaders,
                sepratorCaption: sepratorCaption,
                joinTableData: fetchConfig.type !== 'search_action' ? corePricingConfig.joinTableData.concat(result.fullCollection) : result.fullCollection,
                primaryHeaderDetails: primaryHeader,
                secondaryHeaderDetails: secondaryHeader,
                primaryTable: finalPrimaryCollection,
                secondaryTable: finalSecondaryCollection,
                selectedTab: TOOL_BAR_BUTTONS[0].KEY,
                titleDetails: parsingData.tableTitle,
                pageToken: fetchConfig.pageToken
            });
        } else if (data.length === 0) {
            setCorePricingConfig({
                ...corePricingConfig,
                pageToken: fetchConfig.pageToken
            });
        }
        primaryData = [];
        secondaryData = [
            {
                categoryTitle: 'fareValue',
                data: []
            },
            {
                categoryTitle: 'rule',
                data: []
            },
            {
                categoryTitle: 'footnote',
                data: []
            },
            {
                categoryTitle: 'distribution',
                data: []
            },
            {
                categoryTitle: 'fareClass',
                data: []
            },
            {
                categoryTitle: 'brand',
                data: []
            },
            {
                categoryTitle: 'market',
                data: []
            }
        ];
    }
    useEffect(() => {
        if (parseInt(fetchConfig.totalItem) !== 0)
            parsingOriginalData(fetchConfig.data)
        else {
            setCorePricingConfig({
                ...corePricingConfig,
                joinTableHeaders: [],
                sepratorCaption: 0,
                joinTableData: [],
                primaryHeaderDetails: [],
                secondaryHeaderDetails: [],
                primaryTable: [],
                secondaryTable: [],
                selectedTab: TOOL_BAR_BUTTONS[0].KEY,
                titleDetails: []
            });
        }
    }, [fetchConfig.data]);

    const parsingRequestData = (...parsingData) => {
        isEmptyValue = false;
        const isAnyEmptyObject = [];
        let defaultParsingData = parsingData;
        const newOriginalObject = {};
        const removedList = getClonedCopyCollections(defaultParsingData[0]).filter(list => {
            const subListResult = list.categoryDetails.filter(sublist => {
                if (sublist.values.length > 0) {
                    isEmptyValue = sublist.values.some(item => item === 'Invalid date' || item.trim() === '');
                    // isEmptyValue? isAnyEmptyObject.push(true):isAnyEmptyObject.push(false);
                    if (!isEmptyValue)
                        return sublist;
                }
            });
            if (subListResult.length > 0) {
                list.categoryDetails = subListResult;
                return list;
            }
        });
        removedList.filter((item) => {
            newOriginalObject[item.categeryName.toString().charAt(0).toLowerCase() + item.categeryName.slice(1).split(' ').join('') + (item.categeryName !== 'Fare Class' ? 's' : '')] = [...item.categoryDetails];
        });
        if (Object.values(newOriginalObject).length === 0)
            isEmptyValue = true;
        else
            isEmptyValue = false;
        return newOriginalObject;
    };

    const deleteItems = ({ ...result }) => {
        Object.keys(result).map((list) => {
            const rowItems = result[list].map((item) => {
                const defaultItems = { ...item };
                delete defaultItems.keyCode;
                delete defaultItems.title;
                defaultItems.value = defaultItems.values.toString().toUpperCase();
                delete defaultItems.values;
                return item = defaultItems;
            });
            result[list] = rowItems;
        });
        return result;
    }
    const searchCriteriaParsing = (searchCriteriaConfig) => {
        const getSearchDetails = [...searchCriteriaConfig]
        const filterRecords = getSearchDetails.filter(list => (list.categeryName !== 'Table' && list.categeryName !== 'Products' && list.categeryName !== 'Market'));
        let isTariffNumber = false;
        let isReceivedDate = true;
        filterRecords.map(list => {
            if (list.categeryName === 'Identifier' || list.categeryName === 'Distribution') {
                if (list.categoryDetails.length > 0) {
                    list.categoryDetails.map(subList => {
                        if ((subList.key === 'tariffNumber' || subList.key === 'transmissionDateTime') && subList.values.length > 0) {
                            subList.values.map(value => {
                                if (value && subList.key === 'tariffNumber')
                                    isTariffNumber = true;
                                else if (value && subList.key === 'transmissionDateTime') {
                                    isReceivedDate = moment(value, DateUtil.DATE_FORMATS.DD_MMM_YY_FULL_TIME, true).isValid();
                                }
                            });
                        }
                    });
                }
            }
        });
        if (!isReceivedDate) {
            toast.warn('Received Date field is In valid date time format.Please type correct format(DDMMMYY HH:MM:SS).');
            return;
        }
        const result = parsingRequestData(filterRecords);
        const updatedData = deleteItems(result);
        updatedData.hostCarrier = sessionStorage.getItem('carrierCode');
        updatedData.pageToken = null;
        updatedData.jobId = null;
        if (!isEmptyValue) {
            if (!isTariffNumber) {
                if (!isShowNotification) {
                    setTimeout(() => {
                        setIsShowNotification(false);
                    }, 3000);
                    toast.warn('Tariffnumber field is empty.');
                    setIsShowNotification(true);
                }

            } else {
                setFetchConfig({
                    ...fetchConfig,
                    data: [],
                    isLoading: true,
                    error: '',
                    requestedData: updatedData,
                    type: 'search_action',
                    pageToken: updatedData.pageToken,
                    jobId: updatedData.jobId,
                    isStopAPI: false
                });
                setCorePricingConfig({
                    ...corePricingConfig,
                    isLeftSideLayoutOpen: false,
                    joinTableHeaders: [],
                    sepratorCaption: 0,
                    joinTableData: [],
                    primaryHeaderDetails: [],
                    secondaryHeaderDetails: [],
                    primaryTable: [],
                    secondaryTable: [],
                    selectedTab: TOOL_BAR_BUTTONS[0].KEY,
                    titleDetails: []
                });
                setStopApiRequest(false);
            }
        } else {
            if (!isShowNotification) {
                setTimeout(() => {
                    setIsShowNotification(false);
                }, 3000);
                //toast.warn('Search field is empty.');
                toast.warn('Tariffnumber field is empty.');
                setIsShowNotification(true);
            }
        }
    }
    const handleUpdateSearchCriteriaConfigClick = async (searchCriteriaConfig) => {
        // if (abort.isAbort) {
        //       cancelTokenSource.abort();
        //     handleUpdateSearchCriteriaConfigClick(searchCriteriaConfig);
        //     return;
        // }

        if (fetchConfig.isLoading) {
            //  cancelTokenSource.abort();
            setAbort({
                isAbort: true,
                searchCriteriaDetails: searchCriteriaConfig
            });
            setCorePricingConfig({
                ...corePricingConfig,
                joinTableHeaders: [],
                sepratorCaption: 0,
                joinTableData: [],
                primaryHeaderDetails: [],
                secondaryHeaderDetails: [],
                primaryTable: [],
                secondaryTable: [],
                selectedTab: TOOL_BAR_BUTTONS[0].KEY,
                titleDetails: []
            });
        }
        else {
            searchCriteriaParsing(searchCriteriaConfig);
        }

    };
    const handleStopSearchRequest = () => {
        if (typeof (fetchConfig.pageToken) === 'undefined')
            return;
        //  cancelTokenSource.abort();
        if (cancelToken) {
            cancelToken.cancel('Query canceled');
            setCancelToken(null);
            setStopApiRequest(true);
        }
        // setFetchConfig({
        //     ...fetchConfig,
        //     isStopAPI: true,
        //     isLoading: false,
        //     pageToken: undefined
        // });

    };
    const updateTariffNumber = (isAvailable) => {
        setIsTariffNumberAvailable(isAvailable);
    };
    const showWarning = (message) => {
        if (!isShowNotification) {
            setTimeout(() => {
                setIsShowNotification(false);
            }, 3000);
            toast.warn(message);
            setIsShowNotification(true);
        }
    }
    const searchCriteriaComponent = () => {
        return (<SearchCriteria
            showWarning={showWarning}
            getSearchCriteria={getSearchCriteria}
            isTariffNumberAvailable={isTariffNumberAvailable}
            data={searchCriteriaConfig}
            updateTariffNumber={updateTariffNumber}
            handleSearchCriteriaSearch={handleUpdateSearchCriteriaConfigClick}
            handleStopSearchRequest={() => handleStopSearchRequest()}
        />)
    };
    const getClonedCopyCollections = (list) => {
        return list.map(item => { return { ...item } })
    };

    // useEffect(() => {
    //     if (typeof (fetchConfig.pageToken) === 'undefined')
    //         toast.success('Successfully fetch all data.Export data available now', { backgroundColor: '#268440' });
    //     getTableData({ joinTable: corePricingConfig.joinTableData, primaryTableLength: corePricingConfig.primaryTable.length, totalItem: fetchConfig.totalItem });
    // }, [corePricingConfig.joinTableData]);

    const updateRecords = (item, totalList) => {
        let currentRecord = 0;
        const updatedResult = totalList.map((list) => {
            if (list.key === item.key) {
                if (item.isDefault || item.isDecending) {
                    list.isAscending = true;
                    list.isDefault = false;
                    list.isDecending = false;
                } else if (item.isAscending) {
                    list.isDecending = true;
                    list.isAscending = false;
                }
                currentRecord = list;
            }

            return list;
        });
        return { updatedResult, currentRecord };
    };
    const handleSorting = (item) => {
        const primaryTableObject = updateRecords(item, corePricingConfig.primaryHeaderDetails)
        const secondaryTableObject = updateRecords(item, corePricingConfig.secondaryHeaderDetails)
        const currentRecord = primaryTableObject.currentRecord ? primaryTableObject.currentRecord : secondaryTableObject.currentRecord
        const primaryTableHeader = primaryTableObject.updatedResult;
        const secondaryTableHeader = secondaryTableObject.updatedResult;
        const resultData = calculateJoinData(corePricingConfig.primaryTable, corePricingConfig.secondaryTable);
        let sortedData;
         sortedData = resultData.sort((a, b) => {
            if (!parseInt(a[currentRecord.key]))
                return b[currentRecord.key].toString().localeCompare(a[currentRecord.key].toString());
            else {
                if (item.key !== 'rec dt' && item.key !== 'eff dt' && item.key !== 'gfs dt') {
                    return parseInt(a[currentRecord.key] - b[currentRecord.key])
                } else{
                    return new Date(a[currentRecord.key])> new Date(new Date(b[currentRecord.key]))? 1:-1;
                }
            }
        });
        const sortedResult = currentRecord.isAscending ? sortedData : sortedData.reverse();

        const result = generationgTableObjects(sortedResult);

        setCorePricingConfig({
            ...corePricingConfig,
            //   joinTableHeaders: [...primaryTableHeader, ...secondaryTableHeader],
            primaryHeaderDetails: primaryTableObject.updatedResult,
            secondaryHeaderDetails: secondaryTableObject.updatedResult,
            primaryTable: result.primaryCollection,
            secondaryTable: result.secondaryCollection
        });
    }

    const updateData = (totalList, item, type, value) => {
        const updatedResult = totalList.map((list) => {
            if (type === 'sorting') {
                if (list.key === item.key) {
                    list.isShowFilterControls = !list.isShowFilterControls;
                } else {
                    list.isFilterOpen = false;
                    list.isShowFilterControls = false;
                }
            } else if (type === 'filterChanging') {
                if (list.key === item.key) {
                    list.filterValue = value;
                    list.isFilterApply = value ? true : false;
                } else {
                    list.filterValue = list.filterValue ? list.filterValue : '';
                    list.isFilterApply = list.filterValue ? true : false;
                }
            } else if (type === 'closePopup' && list.key === item.key) {
                list.isFilterOpen = false;
                list.isShowFilterControls = false;
            } else {
                if (list.key === item.key)
                    list.isFilterOpen = true;
                else
                    list.isFilterOpen = false;
            }
            return list;
        });
        return updatedResult;
    };
    const handleFilterChange = (value, item, totalList) => {
        setCorePricingConfig({
            ...corePricingConfig,
            // isFilterApply: true
        })
        setTimeout(() => {
            let finalResult = corePricingConfig.joinTableData.filter((list) => {
                if (list[item.key].toString().includes(value) || list[item.key].toString().includes(value.toUpperCase()) || list[item.key].toString().includes(value.toLowerCase())) {
                    return list;
                }
            });
            const primaryHeader = updateData(corePricingConfig.primaryHeaderDetails, item, 'filterChanging', value);
            const secondaryHeader = updateData(corePricingConfig.secondaryHeaderDetails, item, 'filterChanging', value);
            // column level other already search text(text search) filter.
            const mergedHeaders = [...primaryHeader, ...secondaryHeader]
            mergedHeaders.map(list => {
                if (list.filterValue && item.key !== list.key) {
                    finalResult = finalResult.filter((subList) => {
                        if (subList[list.key].toString().includes(list.filterValue)) {
                            return subList;
                        }
                    });
                }
            });

            const result = generationgTableObjects(finalResult);
            if (finalResult.length > 0) {

                setCorePricingConfig({
                    ...corePricingConfig,
                    //   joinTableHeaders: [...primaryHeader, ...secondaryHeader],
                    primaryHeaderDetails: primaryHeader,
                    secondaryHeaderDetails: secondaryHeader,
                    primaryTable: result.primaryCollection,
                    secondaryTable: result.secondaryCollection
                });
            } else if (finalResult.length === 0 && value) {
                setCorePricingConfig({
                    ...corePricingConfig,
                    primaryTable: [],
                    secondaryTable: []
                });
            } else if (!value) {

                setCorePricingConfig({
                    ...corePricingConfig,
                    //  joinTableHeaders: [...primaryHeader, ...secondaryHeader],
                    primaryHeaderDetails: primaryHeader,
                    secondaryHeaderDetails: secondaryHeader,
                    primaryTable: result.primaryCollection,
                    secondaryTable: result.secondaryCollection
                });
            }
        }, 0);
    };
    const handleEnablesPrimaryHeadersControls = (item, list, isSecondaryTable, isSorting, type) => {

        if (type === 'openPopup') {
            const primaryHeader = isSecondaryTable ? updateData(corePricingConfig.primaryHeaderDetails, item, isSorting ? 'sorting' : 'filtering') : updateData(list, item, isSorting ? 'sorting' : 'filtering');
            const secondaryHeader = isSecondaryTable ? updateData(list, item, isSorting ? 'sorting' : 'filtering') : updateData(corePricingConfig.secondaryHeaderDetails, item, isSorting ? 'sorting' : 'filtering');
            setCorePricingConfig({
                ...corePricingConfig,
                primaryHeaderDetails: primaryHeader,
                secondaryHeaderDetails: secondaryHeader
            });
        } else if (type === 'closeHeader' && !item.isFilterOpen) {
            const primaryHeader = isSecondaryTable ? updateData(corePricingConfig.primaryHeaderDetails, item, 'closePopup') : updateData(list, item, 'closePopup');
            const secondaryHeader = isSecondaryTable ? updateData(list, item, 'closePopup') : updateData(corePricingConfig.secondaryHeaderDetails, item, 'closePopup');
            setCorePricingConfig({
                ...corePricingConfig,
                primaryHeaderDetails: primaryHeader,
                secondaryHeaderDetails: secondaryHeader
            });
        } else if (type !== 'closeHeader' && item.isFilterOpen) {
            const primaryHeader = isSecondaryTable ? updateData(corePricingConfig.primaryHeaderDetails, item, 'closePopup') : updateData(list, item, 'closePopup');
            const secondaryHeader = isSecondaryTable ? updateData(list, item, 'closePopup') : updateData(corePricingConfig.secondaryHeaderDetails, item, 'closePopup');
            setCorePricingConfig({
                ...corePricingConfig,
                primaryHeaderDetails: primaryHeader,
                secondaryHeaderDetails: secondaryHeader
            });
        }
    };

    const handleUniqueItemClick = (item, isScroll) => {
        let result = [];
        if (!isScroll) {
            result = corePricingConfig.primaryHeaderDetails.map(list => {
                list.filterUniqueValues.map(subList => {
                    if (subList.key === item.key)
                        subList.value = !subList.value;
                    return subList;
                });
                return list;
            });
        } else {
            result = corePricingConfig.secondaryHeaderDetails.map(list => {
                list.filterUniqueValues.map(subList => {
                    if (subList.key === item.key)
                        subList.value = !subList.value;
                    return subList;
                });
                return list;
            });
        }
        setCorePricingConfig({
            ...corePricingConfig,
            primaryHeaderDetails: !isScroll ? result : corePricingConfig.primaryHeaderDetails,
            secondaryHeaderDetails: !isScroll ? corePricingConfig.secondaryHeaderDetails : result,
            joinHeaders: !isScroll ? [...result, ...corePricingConfig.secondaryHeaderDetails] : [...corePricingConfig.primaryHeaderDetails, ...result]
        });
    };
    const handlePrimaryTableScroll = (event) => {
        if (secondaryTableReference.current)
            secondaryTableReference.current.scrollTop = event.target.scrollTop;

        let bottom = event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight < 50;
        if (bottom) {
            const updateRequest = fetchConfig.requestedData;
        }
        const isFilterPopupOpen = [...corePricingConfig.primaryHeaderDetails, ...corePricingConfig.secondaryHeaderDetails].some(list => list.isFilterOpen);
        if (isFilterPopupOpen)
            return;

    };
    const handleSecondaryTableScroll = (event) => {
        if (primaryTableReference.current)
            primaryTableReference.current.scrollTop = event.target.scrollTop;
        const isFilterPopupOpen = [...corePricingConfig.primaryHeaderDetails, ...corePricingConfig.secondaryHeaderDetails].some(list => list.isFilterOpen);
        if (isFilterPopupOpen)
            return;
    };
    const handleSelectAllUpdate = (isSelectAll, isScroll, item) => {
        let result = [];
        if (!isScroll) {
            result = corePricingConfig.primaryHeaderDetails.map(list => {
                list.filterUniqueValues.map(subList => {
                    if (list.key === item.key)
                        subList.value = !isSelectAll ? false : true;
                    return subList;
                });
                return list;
            });
        } else {
            result = corePricingConfig.secondaryHeaderDetails.map(list => {
                list.filterUniqueValues.map(subList => {
                    if (list.key === item.key)
                        subList.value = !isSelectAll ? false : true;
                    return subList;
                });
                return list;
            });
        }
        setCorePricingConfig({
            ...corePricingConfig,
            primaryHeaderDetails: !isScroll ? result : corePricingConfig.primaryHeaderDetails,
            secondaryHeaderDetails: !isScroll ? corePricingConfig.secondaryHeaderDetails : result,
            joinHeaders: !isScroll ? [...result, ...corePricingConfig.secondaryHeaderDetails] : [...corePricingConfig.primaryHeaderDetails, ...result]
        });
    }
    const calculateResultDetailsUnique = (collection, headers, item, type) => {
        headers.map((menuList) => {
            const uniqueResult = [... new Set(collection.map(list => list[menuList.key] && list[menuList.key].toString()))];
            uniqueResult.sort();
            if (menuList.key !== item.key) {
                const response = uniqueResult.map((item) => {
                    return {
                        key: item,
                        value: true
                    };
                });
                menuList.filterUniqueValues = getClonedCopyCollections(response);
            } else if (type === 'clear' && menuList.key === item.key) {
                const response = menuList.filterUniqueValues.filter((subItem) => uniqueResult.includes(subItem.key));
                menuList.filterUniqueValues = getClonedCopyCollections(response);
            }
        });
        return headers;
    };

    const handleFilterUniqueItems = (item, isSecondaryTable, type) => {
        setCorePricingConfig({
            ...corePricingConfig,
            isFilterApply: true
        });
        setTimeout(() => {
            const filterTableData = corePricingConfig.joinTableData;
            let filterTableHeader = [...corePricingConfig.primaryHeaderDetails, ...corePricingConfig.secondaryHeaderDetails];
            let filterFinalTableCollection = [];

            const updatedHeaderRows = filterTableHeader.map((list, index) => {
                if (type === 'clear') {
                    if (list.key === item.key) {
                        list.filterUniqueValues = getClonedCopyCollections(corePricingConfig.joinTableHeaders[index].defaultFilterUniqueValues);
                        list.filterUniqueValues.map(subList => subList.value = true);
                        list.width = (item.key === 'cur' || item.key === 'amt' || item.key === 'sur' || item.key === 'yq' || item.key === 'yr') ? item.width - 100 : item.key === 'owrt' ? item.width - 100 : item.key === 'ft' ? item.width - 70 : item.width - 50;
                        list.isFilterApply = false;
                    }
                }
                if (list.filterUniqueValues.every(item => item.value === true)) {
                    list.filterUniqueValues = !list.isFilterApply ? getClonedCopyCollections(corePricingConfig.joinTableHeaders[index].defaultFilterUniqueValues) : getClonedCopyCollections(list.filterUniqueValues);
                }
                if (list.key === item.key && type === 'Apply') {
                    list.width = (item.key === 'cur' || item.key === 'amt' || item.key === 'sur' || item.key === 'yq' || item.key === 'yr') ? item.width - 100 : item.key === 'owrt' ? item.width - 100 : item.key === 'ft' ? item.width - 70 : item.width - 50;
                    list.isFilterApply = true;
                }
                if (!list.isFilterApply) {
                    list.filterUniqueValues.map(subList => subList.value = true)
                }
                return list;
            });
            filterTableData.filter((list) => {
                let unSelectionColumn = [];
                let currentRecordTableKeys = Object.keys(list);
                let currentRecordUpdatedTableKeys = currentRecordTableKeys.filter(item => item !== 'id' && item !== 'isSelect' && item !== 'selectedField' && item !== 'selectedColumn');
                currentRecordUpdatedTableKeys.filter((item, subIndex, filterCollection) => {
                    const uniqueValueList = filterTableHeader.find((header) => header.key === item);
                    const matchRecords = uniqueValueList.filterUniqueValues.length > 0 && uniqueValueList.filterUniqueValues.find(secList => (secList.value === true && ((secList.key.toString() === 'null' && (!list[item].toString() || list[item].toString() === '|')) || (list[item].toString() === secList.key.toString()))));
                    if (!matchRecords)
                        unSelectionColumn.push(item);
                    if (subIndex === filterCollection.length - 1) {
                        if (unSelectionColumn.length === 0)
                            filterFinalTableCollection.push(list)
                    }
                })
            });
            const result = generationgTableObjects(filterFinalTableCollection);
            const primaryHeaderDetails = updateData(corePricingConfig.primaryHeaderDetails, item, 'closePopup');
            const secondaryHeaderDetails = updateData(corePricingConfig.secondaryHeaderDetails, item, 'closePopup');
            calculateResultDetailsUnique(result.primaryCollection, primaryHeaderDetails, item, type);
            calculateResultDetailsUnique(result.secondaryCollection, secondaryHeaderDetails, item, type);

            setCorePricingConfig({
                ...corePricingConfig,
                primaryHeaderDetails: primaryHeaderDetails,
                secondaryHeaderDetails: secondaryHeaderDetails,
                primaryTable: result.primaryCollection,
                secondaryTable: result.secondaryCollection,
                isFilterApply: false
            });
        }, 0);

    }
    const handleClearEvent = (item, list, isSecondaryTable) => {
        handleFilterUniqueItems(item, isSecondaryTable, 'clear');
    }
    const handleRecordClick = (selectedList, selectedItem, selectedColumn, isShiftKeyPress, currentIndex, collection, type) => {
        if (type === 'otherKey') {
            if (!isShiftKeyPress) {
                const currentTableData = calculateJoinData(corePricingConfig.primaryTable, corePricingConfig.secondaryTable);
                const updateResult = getClonedCopyCollections(currentTableData).map(list => {
                    if (list.id === selectedList.id) {
                        list.isSelect = true;
                        list.selectedField = selectedItem;
                        list.selectedColumn = selectedColumn;
                    } else {
                        list.isSelect = false;
                        list.selectedField = '';
                        list.selectedColumn = '';
                    }
                    return list;
                });
                if (selectedItem && selectedColumn) {
                    const result = generationgTableObjects(updateResult);
                    setCorePricingConfig({
                        ...corePricingConfig,
                        primaryTable: result.primaryCollection,
                        secondaryTable: result.secondaryCollection
                    });
                }
            } else {
                let updateResult = [];
                const existingIndex = collection.findIndex(list => list.isSelect);
                const currentTableData = calculateJoinData(corePricingConfig.primaryTable, corePricingConfig.secondaryTable);
                if (existingIndex > currentIndex) {
                    updateResult = getClonedCopyCollections(currentTableData).map((list, index) => {
                        if (index >= currentIndex && index <= existingIndex)
                            list.isSelect = true;
                        return list;
                    });
                } else {
                    updateResult = getClonedCopyCollections(currentTableData).map((list, index) => {
                        if (index >= existingIndex && index <= currentIndex)
                            list.isSelect = true;
                        return list;
                    });
                }
                const result = generationgTableObjects(updateResult);
                setCorePricingConfig({
                    ...corePricingConfig,
                    primaryTable: result.primaryCollection,
                    secondaryTable: result.secondaryCollection
                });
            }
        } else {
            const currentTableData = calculateJoinData(corePricingConfig.primaryTable, corePricingConfig.secondaryTable);
            const updateResult = getClonedCopyCollections(currentTableData).map(list => {
                if (list.id === selectedList.id) {
                    list.isSelect = type === 'ctrlKey' ? !list.isSelect : true;
                    list.selectedField = selectedItem;
                    list.selectedColumn = selectedColumn;
                }
                return list;
            });
            const result = generationgTableObjects(updateResult);
            setCorePricingConfig({
                ...corePricingConfig,
                primaryTable: result.primaryCollection,
                secondaryTable: result.secondaryCollection
            });
        }
    };

    const handleKeyPressEvent = (selectedList, selectedItem, selectedColumn, keyCode, currentIndex, collection, type) => {
        let newDataSelection = {};
        if (type === 'singleSelection')
            currentIndex = collection.findIndex(list => list.isSelect);
        else if (selectedList.isSelect)
            currentIndex = collection.findIndex(list => list.id === selectedList.id);
        if (type === 'multiSelection') {
            if ((keyCode === 38 || keyCode === 40) && collection.filter(list => list.isSelect).length === 1) {
                newDataSelection = keyCode === 38 ? collection[currentIndex - 1] : collection[currentIndex + 1];
            } else {
                const latestUpdateData = keyCode === 38 ? collection.find(list => list.isSelect) : collection.findLast(list => list.isSelect);
                const latestIndex = collection.findIndex(list => list.id === latestUpdateData.id);
                if ((currentIndex > latestIndex && keyCode === 38) || (currentIndex < latestIndex && keyCode === 40))
                    newDataSelection = keyCode === 38 ? collection[latestIndex - 1] : collection[latestIndex + 1];
                else {
                    const latestUpdateData = keyCode === 40 ? collection.find(list => list.isSelect) : collection.findLast(list => list.isSelect);
                    const latestIndex = collection.findIndex(list => list.id === latestUpdateData.id);
                    newDataSelection = collection[latestIndex];
                }
            }
        } else if (type === 'singleSelection') {
            newDataSelection = keyCode === 38 ? collection[currentIndex - 1] : collection[currentIndex + 1];
        }

        if (newDataSelection) {
            const currentTableData = calculateJoinData(corePricingConfig.primaryTable, corePricingConfig.secondaryTable);
            const updateResult = getClonedCopyCollections(currentTableData).map(list => {
                if (type === 'multiSelection') {
                    if (list.id === newDataSelection.id) {
                        list.isSelect = !list.isSelect
                    }
                } else if (type === 'singleSelection') {
                    if (list.id === newDataSelection.id) {
                        list.isSelect = true;
                        list.selectedField = selectedItem;
                        list.selectedColumn = selectedColumn;
                        document.getElementById(list.id).focus();
                    } else {
                        list.isSelect = false;
                        list.selectedField = '';
                        list.selectedColumn = '';
                    }
                }
                return list;
            });
            const result = generationgTableObjects(updateResult);
            if (selectedItem && selectedColumn) {
                setCorePricingConfig({
                    ...corePricingConfig,
                    primaryTable: result.primaryCollection,
                    secondaryTable: result.secondaryCollection,
                    joinTableData: result.fullCollection
                });
            }
        }
    };

    const navigationPagination = () => {
        const totalItems = parseInt(fetchConfig.totalItem);
        if (fetchConfig.totalItem && totalItems !== corePricingConfig.primaryTable.length) {
            if (fetchConfig.data.length !== parseInt(fetchConfig.totalItem))
                setFetchConfig({
                    ...fetchConfig,
                    requestedData: fetchConfig.requestedData,
                    isLoading: true,
                    type: 'pagination_action',
                    error: ''
                });
        }
    };
    const handleScroll = (event, type) => {
        if (secondaryTableReference.current && type === 'primary')
            secondaryTableReference.current.scrollToPosition(event.scrollTop);
        else if (primaryTableReference.current && type === 'secondary')
            primaryTableReference.current.scrollToPosition(event.scrollTop);
    };
    const getSelectedIndex = (selectedRowDetails) => {
        setCorePricingConfig({
            ...corePricingConfig,
            selectedRowDetails: selectedRowDetails
        })
    };
    const getSelectedCellIndex = (selectedIndex) => {
        // setCorePricingConfig({
        //     ...corePricingConfig,
        //     selectedCellIndex: selectedIndex
        // })
    };

    const tableComponent = () => {
        return (
            <div className={`${corePricingConfig.primaryTable.length === 0 && 'default-height'} ${corePricingConfig.joinTableData.length === 0 && !corePricingConfig.isLeftSideLayoutOpen ? 'center-loader' : ''}`}>
                {
                    ((!fetchConfig.isLoading || fetchConfig.type === 'pagination_action') && !corePricingConfig.isFilterApply) ? (corePricingConfig.primaryHeaderDetails.length > 0) ? <div className='spark-flex'>
                        <TableView
                            rowData={corePricingConfig.primaryTable}
                            reference={primaryTableReference}
                            handleScrolling={(event) => handleScroll(event, 'primary')}
                            getSelectedIndex={getSelectedIndex}
                            getSelectedCellIndex={getSelectedCellIndex}
                            selectedRowDetails={corePricingConfig.selectedRowDetails}
                            selectedCellIndexValue={corePricingConfig.selectedCellIndex}
                            headerData={corePricingConfig.primaryHeaderDetails}
                            handleSorting={handleSorting}
                            totalItem={fetchConfig.pageToken ? fetchConfig.totalItem : corePricingConfig.joinTableData.length}
                            isMultiFilter
                            isToolTipShow
                            title={[{ titleName: 'Identifier', width: 0 }]}
                            filterUniqueValues={corePricingConfig.filterUniqueValues}
                            handleScroll={handlePrimaryTableScroll}
                            handleFilterChange={handleFilterChange}
                            handleShowSearchFilters={handleEnablesPrimaryHeadersControls}
                            handleEnablesHeadersControls={handleEnablesPrimaryHeadersControls}
                            handleUniqueItemClick={handleUniqueItemClick}
                            handleSelectAllUpdate={handleSelectAllUpdate}
                            handleClearEvent={handleClearEvent}
                            handleKeyPressEvent={handleKeyPressEvent}
                            handleFilterUniqueItems={handleFilterUniqueItems}
                            handleRecordClick={handleRecordClick}
                            fullData={corePricingConfig.joinTableData}
                            isStopAPI={stopApiRequest}
                            hostCarrier={fetchConfig.requestedData.hostCarrier}
                            isFetchDataCompleted={typeof (fetchConfig.pageToken) === 'undefined' ? true : false}
                        />
                        <TableView
                            rowData={corePricingConfig.secondaryTable}
                            reference={secondaryTableReference}
                            handleScrolling={(event) => handleScroll(event, 'secondary')}
                            isScroll
                            totalItem={fetchConfig.pageToken ? fetchConfig.totalItem : corePricingConfig.joinTableData.length}
                            isLeftSideLayoutOpen={corePricingConfig.isLeftSideLayoutOpen}
                            getSelectedCellIndex={getSelectedCellIndex}
                            getSelectedIndex={getSelectedIndex}
                            selectedRowDetails={corePricingConfig.selectedRowDetails}
                            selectedCellIndexValue={corePricingConfig.selectedCellIndex}
                            headerData={corePricingConfig.secondaryHeaderDetails}
                            handleSorting={handleSorting}
                            isMultiFilter
                            isToolTipShow
                            title={[{ titleName: 'Fare Value', width: 0 }, { titleName: 'Rule', width: 0 }, { titleName: 'Footnote', width: 0 }, { titleName: 'Distribution', width: 0 }, { titleName: 'Fare Class', width: 0 }, { titleName: 'Brand', width: 0 }, { titleName: 'Market', width: 0 }]}
                            sepratorCaption={corePricingConfig.sepratorCaption}
                            filterUniqueValues={corePricingConfig.filterUniqueValues}
                            titleDetails={corePricingConfig.titleDetails}
                            handleScroll={handleSecondaryTableScroll}
                            handleFilterChange={handleFilterChange}
                            handleShowSearchFilters={handleEnablesPrimaryHeadersControls}
                            handleEnablesHeadersControls={handleEnablesPrimaryHeadersControls}
                            handleUniqueItemClick={handleUniqueItemClick}
                            handleSelectAllUpdate={handleSelectAllUpdate}
                            handleClearEvent={handleClearEvent}
                            handleKeyPressEvent={handleKeyPressEvent}
                            handleFilterUniqueItems={handleFilterUniqueItems}
                            handleRecordClick={handleRecordClick}
                            fullData={corePricingConfig.joinTableData}
                            isStopAPI={stopApiRequest}
                            hostCarrier={fetchConfig.requestedData.hostCarrier}
                            isFetchDataCompleted={typeof (fetchConfig.pageToken) === 'undefined' ? true : false}
                        />
                    </div> : <div className='spark-flex spark-align-items-center no-record-text spark-bold'>No fare result found.</div> : (fetchConfig.isLoading || corePricingConfig.isFilterApply) && <Loader className={` ${corePricingConfig.isLeftSideLayoutOpen ? 'loader-container-full' : 'core-pricing-fares-loader'}`} size={SIZE.SMALL} />
                }
            </div>
        );
    }

    const handleStatusLeftSideLayout = (isLeftSideLayoutOpen) => {
        setCorePricingConfig({
            ...corePricingConfig,
            isLeftSideLayoutOpen
        });
    };

    const handleSearchCriteriaSearch = () => {
        setCorePricingConfig({
            ...corePricingConfig,
            isLeftSideLayoutOpen: !corePricingConfig.isLeftSideLayoutOpen
        });
    };

    return (
        <div className='core-pricing-fares-root-view'>
            <div className='row core-pricing-fares-root-view-padding-left-right'>
                <LayoutTwoVerticalGrids
                    isExpanded={corePricingConfig.isLeftSideLayoutOpen}
                    leftComponent={searchCriteriaComponent()}
                    rightComponent={tableComponent()}
                    isCorePricing
                    handleStatusLeftSideLayout={handleStatusLeftSideLayout}
                />
            </div>
        </div>
    )
};

CorePricingFares.propTypes = {
    app: object,
    loadTime: string,
    getTableData: func,
    getSearchCriteriaParent: func,
    getFullDataIsAvailable: func
};

export default CorePricingFares;